import { useEffect } from 'react';
import { useExperimentContext } from './useExperimentContext';
import { CONTROL } from '../../experiments/experiments';
import type { ExperimentCode, VariantOf } from '../../experiments/experiments';

/**
 * Returns the variant shown for `code` on this page load, or 'control' when
 * this payment is not in the experiment. Fires a page-deduped exposure event
 * (post-commit) whenever a resolution exists — including when the backend
 * assigned a variant but the page shows control (snapshot/hardstop override).
 */
export function useExperiment<C extends ExperimentCode>(code: C): VariantOf<C> {
  const { getResolution, fireExposure } = useExperimentContext();
  const r = getResolution(code);

  useEffect(() => {
    if (r) {
      fireExposure(code);
    }
  }, [code, r, fireExposure]);

  return (r?.shownVariant ?? CONTROL) as VariantOf<C>;
}
